// extracted by css-extract-rspack-plugin
export default {"NewRulesetButton":"OverviewPage-module__NewRulesetButton__h4TKIw1"};